/* eslint react-hooks/rules-of-hooks: "warn" */
import { useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { ContextMenuPlugin } from '../../../context-menu';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = (_: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();

    const item = {
        name: $t((v) => v.contextMenuLayer.upload.addImage),
        type: 'addImage',
        onClick: () => {
            framework.getInstance(ContextMenuPlugin).addImage();
        },
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 1,
    sort: 2,
    render,
} as IExportContextMenuItem;
